import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineSparkles } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import UpgradePromptContent, { PremiumBenefit } from "./UpgradePromptContent";

interface FeatureUpgradePromptProps {
  featureName?: string;
  featureDescription?: string;
  benefits?: string[];
  benefitObjects?: PremiumBenefit[];
  title?: string;
  description?: string;
  icon?: React.ComponentType<any>;
  iconTheme?: "yellow" | "blue" | "purple" | "green";
  upgradeText?: string;
  onUpgrade?: () => void;
  onCancel?: () => void;
  className?: string;
  flat?: boolean;
}

const FeatureUpgradePrompt: React.FC<FeatureUpgradePromptProps> = ({
  featureName,
  featureDescription,
  benefits = [],
  benefitObjects,
  title,
  description,
  icon = HiOutlineSparkles,
  iconTheme = "blue",
  upgradeText,
  onUpgrade,
  onCancel,
  className = "",
  flat = false,
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate("/control-panel/billing");
    }
  };

  const finalTitle =
    title ||
    (featureName
      ? `${t("dashboard.features.upgrade.unlock")} ${featureName}`
      : "");

  const finalDescription = description || featureDescription || "";

  const finalBenefits: PremiumBenefit[] =
    benefitObjects ||
    benefits.map((benefit, index) => ({
      id: `benefit-${index}`,
      text: benefit,
    }));

  const finalUpgradeText =
    upgradeText || (t("dashboard.features.upgrade.button") as string);

  return (
    <UpgradePromptContent
      title={finalTitle}
      description={finalDescription}
      benefits={finalBenefits}
      icon={icon}
      iconTheme={iconTheme}
      upgradeText={finalUpgradeText}
      onUpgrade={handleUpgrade}
      onCancel={onCancel}
      className={className}
      flat={flat}
    />
  );
};

export default FeatureUpgradePrompt;
